import { useCallback, useEffect, useState } from 'react';
import { obtenerTurnosDeUsuario, cancelarTurno } from '../../api/turnos';

// Encapsula toda la comunicación con el backend para "Mis turnos":
// cargar la lista y cancelar un turno. El componente que lo use no
// necesita saber nada de fetch/axios, solo consume el resultado.
export function useTurnosUsuario(pacienteId) {
  const [turnos, setTurnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await obtenerTurnosDeUsuario(pacienteId);
      setTurnos(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.message || 'No se pudieron cargar los turnos.');
    } finally {
      setLoading(false);
    }
  }, [pacienteId]);

  useEffect(() => { cargar(); }, [cargar]);

  const cancelar = async (turnoId) => {
    await cancelarTurno(pacienteId, turnoId);
    await cargar();
  };

  return { turnos, loading, error, cancelar };
}